export default "__VITE_ASSET__CNv8A5FA__"